var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"viewall-gifts"}},[(_vm.loading)?_c('Loader'):_c('VgiftsPanel',{attrs:{"gifts":_vm.gifts,"view_all":true,"public_view":_vm.public_view}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }